import { gql } from "@apollo/client";

export const GET_QUALITY_OF_LIFE_INDICATORS_BY_PATIENT_ID = gql`
  query QualityOfLifeIndicatorsByPatientId($patient_id: ID!) {
    qualityOfLifeIndicatorsByPatientId(patient_id: $patient_id) {
      _id
      patient_id
      date
      name
      value
      max_value
      config_id
      is_custom
      createdAt
    }
  }
`;

export const GET_QUALITY_OF_LIFE_INDICATOR_BY_ID = gql`
  query QualityOfLifeIndicatorById($id: ID!) {
    qualityOfLifeIndicatorById(_id: $id) {
      _id
      patient_id
      date
      name
      value
      max_value
      config_id
      is_custom
      createdAt
    }
  }
`;

export const GET_QUALITY_OF_LIFE_INDICATORS_BY_IDS = gql`
  query QualityOfLifeIndicatorsByIds($ids: [ID!]!) {
    qualityOfLifeIndicatorsByIds(ids: $ids) {
      _id
      patient_id
      date
      name
      value
      max_value
      config_id
      is_custom
      createdAt
    }
  }
`;

export const GET_QUALITY_OF_LIFE_INDICATOR_CONFIGS = gql`
  query QualityOfLifeIndicatorConfigs {
    qualityOfLifeIndicatorConfigs {
      _id
      name
      max_value
    }
  }
`;

export const GET_CUSTOM_QUALITY_OF_LIFE_INDICATOR_CONFIGS = gql`
  query CustomQualityOfLifeIndicatorConfigs {
    customQualityOfLifeIndicatorConfigs {
      _id
      name
      max_value
    }
  }
`;
